import { h, Component } from 'preact'
import style from './index.scss'

import Icon from '../Icon'

class HScroll extends Component {
  saveRef = ref => this.inner = ref

  state = {
    active: false
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.active !== nextState.active || this.props !== nextProps
  }

  handleResize = () => {
    const {clientWidth, scrollWidth} = this.inner
    this.setState({active: clientWidth < scrollWidth})
  }

  render({children}, {active}) {
    return (
      <div class={style.normal}>
        <div class={style.scroll}>
          <div ref={this.saveRef} class={style.scrollable}>
            {children}
          </div>
        </div>
        <div class={active ? style.arrowsVisible : style.arrows}><Icon icon="swipe" class={style.icon} /></div>
      </div>
    )
  }
}

export default HScroll



// WEBPACK FOOTER //
// ./components/HScroll/index.js